import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginRequestModel } from '../model/login-request.model';
import { EnvconfigService } from './envconfig.service';
import { EncryptDecryptService } from './EncryptDecryptService.service';
import { ILogOutResponse } from '../interface/logOut.interface';
 

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private url: string = '';
  menu: any = [];

  constructor(
    protected http: HttpClient,
    private router: Router,
    private environment: EnvconfigService,
    private encryptService: EncryptDecryptService,
  ) {
    let _menu_key = sessionStorage.getItem('menu');
    if (_menu_key != null) {
      let bytes = this.encryptService.decrypt(
        _menu_key,
        environment.get('keyCaptcha'),
      );
      this.menu = JSON.parse(bytes);
    }
    this.url = `${environment.get('apiSucURL')}/cuentas-usuarios`;
  }

  login(usuario: LoginRequestModel, captchaToken?: string) {
    const options = captchaToken
      ? { headers: new HttpHeaders({ 'X-Captcha-Token': captchaToken }) }
      : {};

    return this.http.post<any>(`${this.url}/iniciar-sesion`, usuario, options);
  }

  estaLogueado() {
    let token = sessionStorage.getItem(this.environment.get('TOKEN_NAME'));
    return token != null;
  }

  cerrarSesion() {
    sessionStorage.getItem(this.environment.get('TOKEN_NAME'));
    sessionStorage.clear();
    localStorage.clear();
    this.router.navigate(['seguridad/login']);
  }

  getmenu(menu: any) {
    let ciphertext = this.encryptService.encrypt(
      JSON.stringify(menu),
      this.environment.get('keyCaptcha'),
    );
    sessionStorage.setItem('menu', ciphertext);
    this.menu = menu;
    return this.menu;
  }

  desabilitarToken() {
    const s_token = sessionStorage.getItem(this.environment.get('TOKEN_NAME'))!;
    let _token = this.encryptService.decrypt(
      s_token,
      this.environment.get('keyCaptcha'),
    );
    
 
    return this.http.post<ILogOutResponse>(
      `${this.url}/cerrar-sesion`,
      {},
      {
        headers: new HttpHeaders({ Authorization: `Bearer ${_token}` }),
      },
    );
  }
}
